import { render } from "./TheSignin.vue?vue&type=template&id=5074c85a&scoped=true"
import script from "./TheSignin.vue?vue&type=script&lang=js"
export * from "./TheSignin.vue?vue&type=script&lang=js"

import "./TheSignin.vue?vue&type=style&index=0&id=5074c85a&scoped=true&lang=scss"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5074c85a"]])

export default __exports__